import { Component, OnDestroy, OnInit } from '@angular/core';
import { HomeworkService } from '../../../../services/homework.service';
import { HomeworkLink } from '../../../../models/homework-link';
import { AssetService } from '../../../../services/asset.service';
import { CommunicationService } from '../../../../services/communication.service';
import { Subscription } from 'rxjs';
import { ApplicationStateService } from '../../../../services/application-state.service';
import { HomeworkItemComponent } from './homework-item/homework-item.component';
import { HomeworkFormComponent } from './homework-form/homework-form.component';
import { AssetPipe } from '../../../../pipes/asset.pipe';
import { TranslationPipe } from '../../../../pipes/translation.pipe';

@Component({
    selector: 'sidebar-homework',
    templateUrl: './homework.component.html',
    styleUrls: ['./homework.component.scss'],
    standalone: true,
    imports: [
        HomeworkItemComponent,
        HomeworkFormComponent,
        AssetPipe,
        TranslationPipe
    ]
})
export class HomeworkComponent implements OnInit, OnDestroy {

    homeworks: Array<HomeworkLink>;
    homeworkUsed: Array<HomeworkLink>;
    homeworkTeamTeaching: Array<HomeworkLink>;
    subscription: Subscription;
    homeworkRemovedSubscription: Subscription;
    isTeacher;
    isLoggedIn;
    isDigi4SchoolUser;
    bookAccessCode;
    loading = false;

    constructor(public homeworkService: HomeworkService,
                public applicationStateService: ApplicationStateService,
                public assetService: AssetService,
                private communicationService: CommunicationService
    ) {
        this.subscription = this.communicationService.homeworkSavedAnnounced$.subscribe((homework: HomeworkLink) => {
            if (this.homeworks && !homework.test) {
                this.homeworks.unshift(homework as HomeworkLink);
            }
        });
        this.homeworkRemovedSubscription = this.communicationService.homeworkRemovedAnnounced$.subscribe(() => {
            if (this.homeworks) {
                this.homeworkService.getHomeworkLinks(false).then(value => {
                    this.homeworks = value[0];
                });
            }
        });
        this.isTeacher = this.applicationStateService.userData.isTeacher;
        this.isLoggedIn = this.applicationStateService.userData.loggedIn;
        this.isDigi4SchoolUser = this.applicationStateService.userData.digi4SchoolUser;
        this.bookAccessCode = this.applicationStateService.userData.bookAccessCode;
    }

    ngOnInit(): void {
        this.homeworkService.getHomeworkLinks(false).then((value => {
            this.homeworks = value[0];
            this.homeworkUsed = value[1];
            this.homeworkTeamTeaching = value[2];
        }));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.homeworkRemovedSubscription.unsubscribe();
    }
}
